import { useTranslations } from 'next-intl'
import {
  Wifi,
  Car,
  UtensilsCrossed,
  Tv,
  Wind,
  Droplets,
  Coffee,
  Bath,
  Dumbbell,
  Waves,
  ShieldCheck,
  CigaretteOff,
  Snowflake,
  Mountain,
  Shirt,
  Phone,
  Sparkles,
  type LucideIcon,
} from 'lucide-react'

const AMENITY_ICONS: Record<string, LucideIcon> = {
  wifi: Wifi,
  'free wifi': Wifi,
  parking: Car,
  'free parking': Car,
  'valet parking': Car,
  breakfast: UtensilsCrossed,
  restaurant: UtensilsCrossed,
  tv: Tv,
  television: Tv,
  'flat-screen tv': Tv,
  'air conditioning': Wind,
  'air conditioner': Wind,
  ac: Wind,
  pool: Waves,
  'swimming pool': Waves,
  gym: Dumbbell,
  fitness: Dumbbell,
  spa: Droplets,
  'hot tub': Droplets,
  jacuzzi: Droplets,
  coffee: Coffee,
  minibar: Coffee,
  'mini bar': Coffee,
  bathtub: Bath,
  'rain shower': Bath,
  safe: ShieldCheck,
  'non-smoking': CigaretteOff,
  'city view': Mountain,
  'mountain view': Mountain,
  'sea view': Mountain,
  'skyline view': Mountain,
  balcony: Mountain,
  laundry: Shirt,
  'room service': Phone,
  'king bed': Sparkles,
  'queen bed': Sparkles,
  'twin beds': Sparkles,
  'snow flake': Snowflake,
}

function getAmenityIcon(amenity: string): LucideIcon {
  const key = amenity.toLowerCase().trim()
  return AMENITY_ICONS[key] || Sparkles
}

interface PropertyAmenitiesProps {
  amenities: string[]
}

export function PropertyAmenities({ amenities }: PropertyAmenitiesProps) {
  const t = useTranslations('booking.propertyDetail')

  return (
    <section>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
        {t('amenities')}
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {amenities.map((amenity) => {
          const Icon = getAmenityIcon(amenity)
          return (
            <div
              key={amenity}
              className="flex items-center gap-2.5 px-3 py-2.5 rounded-lg bg-white dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/50"
            >
              <Icon className="h-4.5 w-4.5 text-gray-600 dark:text-gray-400 shrink-0" />
              <span className="text-sm text-gray-700 dark:text-gray-300">{amenity}</span>
            </div>
          )
        })}
      </div>
    </section>
  )
}
